
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import TrustSection from './components/TrustSection';
import TestimonialSection from './components/TestimonialSection';
import AreasSection from './components/AreasSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  useEffect(() => {
    document.title = 'Vaciado de Pisos y Limpieza Extrema en Castelldefels | JUSTCLEAN';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Servicio profesional de vaciado de pisos, locales y limpieza por síndrome de Diógenes en Castelldefels. Disponibles 24/7. Presupuesto sin compromiso. ☎️ 602 36 59 96');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "JUSTCLEAN CASTELLDEFELS",
      "image": `${import.meta.env.VITE_SITE_URL || 'https://castelldefels.justclean.es'}/logo.png`,
      "description": "Servicio profesional de vaciado de pisos, locales y limpieza por síndrome de Diógenes en Castelldefels y Baix Llobregat Sud",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Passeig Marítim 234",
        "addressLocality": "Castelldefels",
        "addressRegion": "Barcelona",
        "postalCode": "08860",
        "addressCountry": "ES"
      },
      "telephone": "+34602365996",
      "email": "info@castelldefels.justclean.es",
      "url": import.meta.env.VITE_SITE_URL || 'https://castelldefels.justclean.es',
      "openingHours": "Mo-Su 00:00-23:59",
      "priceRange": "€€",
      "areaServed": [
        {
          "@type": "City",
          "name": "Castelldefels"
        },
        {
          "@type": "City",
          "name": "Gavà"
        },
        {
          "@type": "City",
          "name": "Viladecans"
        },
        {
          "@type": "City",
          "name": "El Prat de Llobregat"
        },
        {
          "@type": "City",
          "name": "Sant Boi de Llobregat"
        },
        {
          "@type": "City",
          "name": "Sitges"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Servicios de Limpieza y Vaciado",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vaciado de Pisos y Casas",
              "description": "Servicio completo de vaciado de viviendas con retirada de muebles y enseres"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vaciado de Locales Comerciales",
              "description": "Vaciado profesional de locales comerciales y oficinas"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Limpieza por Síndrome de Diógenes",
              "description": "Limpieza especializada en casos de acumulación compulsiva y suciedad extrema"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Retirada de Muebles y Electrodomésticos",
              "description": "Recogida y gestión de residuos voluminosos"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Pintura Final",
              "description": "Servicio de pintura para dejar el espacio listo"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Pequeñas Reparaciones",
              "description": "Reparaciones menores para entregar el inmueble en perfectas condiciones"
            }
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <TrustSection />
      <ServicesGrid />
      <AreasSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
};

export default HomePage;
